export const validateNotEmpty = (value) => {
  return value.length !== 0
}

export const validateIco = (value) => {
  return /^\d{8}$/.test(value)
}

export const validateDic = (value) => {
  return /^CZ\d{8,10}$/.test(value)
}

export const validateEmail = (value) => {
  return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value)
}



// WEBPACK FOOTER //
// ./src/utils/validation.js